import { Link } from 'react-router-dom';
import type { Drama } from '@/types/content';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      data-product-shop
      className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={drama.cover}
          alt={`${drama.title} 剧集封面`}
          title={`${drama.title} - 电视剧剧情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 px-2 py-1 rounded-md bg-accent-500 text-background-50 text-[11px] font-bold">
          {drama.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 px-2 py-1 rounded-md bg-primary-950/80 text-background-100 text-[11px] backdrop-blur-sm">
          {drama.status}
        </span>
      </div>
      <div className="flex flex-col gap-2 p-3 md:p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {drama.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed min-h-[2.5rem]">{drama.synopsis}</p>
        <div className="flex flex-wrap items-center gap-1.5">
          {drama.genres.slice(0, 2).map((genre) => (
            <span key={genre} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]">
              {genre}
            </span>
          ))}
          <span className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-500 text-[11px]">{drama.region}</span>
        </div>
        <div className="flex items-center justify-between pt-1 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500"></i>
            热度 {drama.heat}
          </span>
          <span>{drama.updateTime}</span>
        </div>
      </div>
    </Link>
  );
}